// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { Dealer } from './types';

export interface ActionGetDealerAPI extends Action {
    page?: number
    limit?: number
    query?: string
    group?:string
    id?:string
}

export const getDealerAPI = (page?: number, limit?: number, query?: string, group?:string, id?:string): ActionGetDealerAPI => ({
    type: ACTIONS.GET_DEALER_API_REQUEST,
    page,
    limit,
    query,
    group,
    id
});

export interface ActionGetDealerApiSuccess extends Action {
    dealers: Dealer[]
    page?: number
}

export const getDealerAPISuccess = (dealers: Dealer[], page?: number): ActionGetDealerApiSuccess => ({
    type: ACTIONS.GET_DEALER_API_SUCCESS,
    dealers,
    page
});

export const getDealerAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_DEALER_API_ERROR,
    error
});

export const dealersLoadMore = () => ({
    type: ACTIONS.DEALERS_LOAD_MORE
})

export interface ActionEditDealerSearchQuery extends Action {
    query: string
}

export const editDealerSearchQuery = (query: string): ActionEditDealerSearchQuery => ({
    type: ACTIONS.EDIT_DEALER_SEARCH_QUERY,
    query
})

//Edit Selected Dealer
export interface ActionEditSelectedDealer extends Action {
    dealer?: Dealer
}

export const editSelectedDealer = (dealer?: Dealer): ActionEditSelectedDealer => ({
    type: ACTIONS.EDIT_SELECTED_DEALER,
    dealer
})

//Update Selected Dealer

export interface ActionUpdateSelectedDealerById extends Action {
    dealerId: string
}

export interface ActionUpdateSelectedDealerLMPackage extends Action {
    dealerId: string;
    lmPackage: string;
}


export const updateSelectedDealer = (dealerId: string): ActionUpdateSelectedDealerById => {
    return {
        type: ACTIONS.UPDATE_SELECTED_DEALER,
        dealerId
    }
}

export const updateSelectedDealerLMPackage = (dealerId: string, lmPackage: string): ActionUpdateSelectedDealerLMPackage => {
  return {
      type: ACTIONS.UPDATE_SELECTED_DEALER_LMPACKAGE,
      dealerId,
      lmPackage
  }
}

export interface ActionUpdateSelectedDealerByIdSuccess extends Action {
    dealer: Dealer
}

export const updateSelectedDealerSuccess = (dealer: Dealer): ActionUpdateSelectedDealerByIdSuccess => {
    return {
        type: ACTIONS.UPDATE_SELECTED_DEALER_SUCCESS,
        dealer
    }
}


//Get Dealer By Id
export interface ActionGetDealerById extends Action {
    dealerId: string
}

export const getDealerByIdAPI = (dealerId: string): ActionGetDealerById => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_REQUEST,
        dealerId
    }
}

export interface ActionGetDealerByIdSuccess extends Action {
    dealer: Dealer
}

export const getDealerByIdAPISuccess = (dealer: Dealer): ActionGetDealerByIdSuccess => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_SUCCESS,
        dealer
    }
}

export interface ActionGetDealerByIdError extends Action {
    error: any
}

export const getDealerByIdAPIError = (error: any): ActionGetDealerByIdError => {
    return {
        type: ACTIONS.GET_DEALER_BY_ID_API_ERROR,
        error
    }
}